import { defaultUserAvatar } from './design';

// 获取用户头像
export const getUserAvatar = (avatar?: string): string => {
  return avatar
    ? avatar.indexOf('http') > -1 || avatar.indexOf('base64,') > -1
      ? avatar
      : defaultUserAvatar || `${window.location.origin}${avatar}` // 暂时采用默认头像
    : defaultUserAvatar;
};
